module.exports = __webpack_public_path__ + "img/yi5.cf795bcb.jpg";